export default (endpoint, { inspirations, inspirationsCount }) => ({
	inspirations: inspirations,
	inspirationsCount: inspirationsCount,
	page: 2,
	order: 'asc',

	isLoading: false,

	loadMore() {
		this.isLoading = true;
		fetch(
			`${endpoint}?page=${this.page}&orderBy=price&order=${this.order}`,
			{
				method: 'GET',
			}
		).then((resp) => {
			if (resp.ok) {
				resp.json().then((json) => {
					this.inspirations = this.inspirations.concat(
						json.data.items
					);
					this.inspirationsCount = json.data.pagination.total;
					this.page++;
					this.isLoading = false;
					this.$nextTick(() => this.$dispatch('lightboxlinkreload'));
				});
			} else {
				this.isLoading = false;
			}
		});
	},

	orderChanged() {
		this.inspirations = [];
		this.page = 1;
		this.loadMore();
	},

	init() {
		this.$watch('order', (_) => {
			orderChanged();
		});
	},
});
